import React, { useState, useEffect } from 'react';
import { fetchChessData } from '../../services/chessApiService';

const ChessPlatformBubbleTab = ({ platform, username, onClose, accentColor = '#749555' }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const platformConfig = {
    chessCom: {
      name: 'Chess.com',
      logo: '/Images/Chesscom.png',
      url: `https://chess.com/member/${username}`
    },
    lichess: {
      name: 'Lichess',
      logo: '/Images/LiChess.png',
      url: `https://lichess.org/@/${username}`
    }
  };

  const config = platformConfig[platform];
  
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const result = await fetchChessData(platform, username);
      setData(result);
      setLoading(false);
    };

    if (username && platform) {
      loadData();
    }
  }, [platform, username]);
  
  if (!config || !username) {
    return null;
  }

  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="bg-gray-900 border-2 rounded-2xl shadow-lg transition-all duration-200" style={{ borderColor: accentColor }}>
        {/* Header with Close Button */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 sm:w-8 sm:h-8 bg-gray-700 rounded-full flex items-center justify-center overflow-hidden">
              <img
                src={config.logo}
                alt={config.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">{config.name} Profile</h3>
              <p className="text-sm text-gray-300">@{username}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-red-900/30 hover:bg-red-900/50 flex items-center justify-center transition-colors border border-red-500"
            title="Close"
          >
            <i className="fas fa-times text-red-400"></i>
          </button>
        </div>

        {/* API Data Section */}
        <div className="p-6">
          {loading ? (
            <div className="text-center py-8">
              <i className="fas fa-spinner fa-spin text-gray-400 text-3xl mb-4"></i>
              <p className="text-gray-300">Loading data...</p>
            </div>
          ) : data ? (
            <div className="space-y-4 text-center text-white">
              {data.rating > 0 && (
                <div className="text-2xl font-bold">
                  🏆 Rating: {data.rating}
                </div>
              )}
              {data.gameCount > 0 && (
                <div className="text-lg">
                  🎯 Games Played: {data.gameCount.toLocaleString()}
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-8">
              <i className="fas fa-exclamation-circle text-red-400 text-3xl mb-4"></i>
              <p className="text-gray-300">Unable to load data</p>
            </div>
          )}
        </div>

        {/* Visit Profile Button */}
        <div className="p-4 border-t border-gray-700">
          <a
            href={config.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex items-center justify-center px-6 py-3 text-white rounded-lg font-medium transition-opacity hover:opacity-90"
            style={{ backgroundColor: accentColor }}
          >
            <i className="fas fa-external-link-alt mr-2"></i>
            Visit {config.name} Profile
          </a>
        </div>
      </div>
    </div>
  );
};

export default ChessPlatformBubbleTab;